<template>
  <SwiperSlider ref="mySwiper" :options="swiperOptions" class="footerLogotypes">
    <div
      v-for="(item, index) in logotypes"
      :key="index"
      class="footerLogotypes__slide swiper-slide"
    >
      <img
        :data-src="item.src"
        :width="item.width"
        :height="item.height"
        :alt="item.alt"
        class="swiper-lazy"
      />
    </div>
  </SwiperSlider>
</template>

<script>
import SwiperSlider from '~/components/SwiperSlider';

export default {
  name: 'FooterLogotypes',
  components: { SwiperSlider },
  props: {
    logotypes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        loop: true,
        speed: 900,
        spaceBetween: 0,
        autoplay: {
          delay: 1500,
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 5,
        },
        breakpoints: {
          500: {
            slidesPerView: 4,
          },
          700: {
            slidesPerView: 6,
            loop: false,
          },
          1200: {
            slidesPerView: 9,
            loop: false,
            autoplay: false,
          },
        },
      },
    };
  },
};
</script>

<style lang="scss">
.footerLogotypes {
  $root: &;
  width: 100%;

  &__slide {
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
    padding: 0 15px;

    img {
      max-width: 100%;
      max-height: 100%;
      height: auto;
      width: auto;
    }
  }
}
</style>
